"use client"

import { useEffect, useRef, useState } from "react"
import Index from "../../../Index"
import Pagination from "../../../../components/common/Pagination"
import PagesIndex from "../../../PagesIndex"
import {
    getHeadOfTheFamilyReport,
    getSahaySubTypeList,
    getSahayTypeList,
    listYearOfSahay,
} from "../../../../redux/features/AddService"

import { useSelector } from "react-redux"
import PageLoading from "../../../../components/common/pageLoading/PageLoading"
import FileExcel from "../../../../components/common/excelSheet/FileExcel"
import { Autocomplete } from "@mui/material"
import RowPerPageDropdown from "../../../../components/common/paginationRowPerpage/RowPerPageDropdown"
import { useReactToPrint } from "react-to-print"
import PrintReport from "../../../../components/common/printReport/PrintReport"
import { useNavigate } from "react-router-dom"

export default function HeadOfTheFamilyReport() {
    const { getSubSahayReportList } = PagesIndex.useSelector((state) => state?.admin)

    const Navigate = useNavigate()
    const fileName = "Head Of the family CSV"
    const [excel, setExcel] = useState([])
    const [printData, setPrintData] = useState([])
    const [pageData, setPageData] = useState([])
    const [loader, setLoader] = useState(false)
    const [rowPerPage, setRowPerPage] = useState("25")
    const dispatch = PagesIndex.useDispatch()
    const [filter, setFilter] = useState("")
    const [filterName, setFilterName] = useState("")
    const [sahayFilter, setSahayFilter] = useState("")
    const [filterYear, setFilterYear] = useState("")
    const [searchedData, setSearchedData] = useState([])
    const [sahaySubTypeList, setSahaySubTypeList] = useState([])
    const [sahayTypeList, setSahayTypeList] = useState([])
    const [yearOfSahayList, setYearOfSahayList] = useState([])
    const [filterReportData, setFilterReportData] = useState([])
    const [listData, setListData] = useState([])
    const { rollPermissionData } = useSelector((state) => state.admin)

    const rollData = JSON.parse(localStorage?.getItem("RollName"))?.toLowerCase()
    // Print Reports
    const componentRef = useRef()
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    })

    useEffect(() => {
        if (filterYear) {
            setLoader(true)
            dispatch(getHeadOfTheFamilyReport(filterYear)).then((res) => {
                if (res?.payload?.status == 200) {
                    setListData(res?.payload?.data)
                    setLoader(false)
                } else {
                    setListData([])
                }
                setLoader(false)
            })
        }
    }, [filterYear])

    // Filter Data
    useEffect(() => {
        if (filter || filterName || filterYear || sahayFilter) {
            const filterData = listData?.filter((ele) => {
                // Check all filter conditions
                const matchesFamilyId = !filter || ele.FamilyId === filter
                const matchesName = !filterName || ele.Name?.toLowerCase()?.includes(filterName?.toLowerCase())
                const matchesSahayFilter = !sahayFilter || ele.SahayCategory === sahayFilter

                // Return true if all active filters match
                return matchesFamilyId && matchesName && matchesSahayFilter
            })
            setFilterReportData(filterData || [])
        } else {
            // If no filters are active, show all data
            setFilterReportData(listData || [])
        }
    }, [filter, filterName, filterYear, listData, sahayFilter])

    // Copy original data to searched data
    useEffect(() => {
        setSearchedData(filterReportData)
    }, [filterReportData])

    // Search on table
    const requestSearch = (searched) => {
        if (!searched) return setSearchedData(filterReportData)
        setSearchedData(
            filterReportData?.filter(
                (item) =>
                    item?.Name?.toString()?.toLowerCase().includes(searched?.toLowerCase())
            ),
        )
    }

    useEffect(() => {
        if (filterReportData?.length > 0) {
            const customPrintHeadings = filterReportData?.map((item) => ({
                "Family Id ": item?.FamilyId,
                Name: item?.Name,
                Age: item?.Age,
                " Gender": item?.Gender,
                "Blood Group": item?.Bloodgroup,
                "Marital Status": item?.Maritalstatus,
                Gnyati: item?.Gnyati,
                "Parent FID": item?.patanHeadDetails,
                "Old Family Id": item?.oldFamilyHeadDetails,
                Country: item?.Address?.Country,
                State: item?.Address?.State,
                City: item?.Address?.City,
                Pincode: item?.Address?.Pincode,
                Address1: item?.Address?.Address1,
                Address2: item?.Address?.Address2,
                Area: item?.Address?.Area,
                Mohollo: item?.Address?.Mohollo,
            }))

            // setExcel(customHeadings);
            setExcel(customPrintHeadings)
            setPrintData(customPrintHeadings)
        }
    }, [filterReportData])

    //get Sub sahay list
    const getSahaySubTypeData = async (id) => {
        dispatch(getSahaySubTypeList(id)).then((res) => {
            if (res?.payload) {
                setSahaySubTypeList(res?.payload)
            } else {
                setSahaySubTypeList([])
            }
        })
    }

    const fetchAllYearOfSahay = () => {
        //Get current financial year
        function getCurrentFinancialYear() {
            var financialYear = ""
            var today = new Date()
            if (today.getMonth() + 1 <= 3) {
                financialYear = today.getFullYear() - 1 + "-" + today.getFullYear()
            } else {
                financialYear = today.getFullYear() + "-" + (today.getFullYear() + 1)
            }
            return financialYear
        }
        const financialYear = getCurrentFinancialYear()
        const filterFromYear = financialYear.split("-")[0]
        const filterToYear = financialYear.split("-")[1]

        // const currentYear = new Date().getFullYear();
        dispatch(listYearOfSahay()).then((data) => {
            if (data?.payload) {
                const filterCurrYear = data?.payload?.filter((ele) => {
                    return ele?.fromYear == filterFromYear && ele?.toYear == filterToYear
                    // return ele?.fromYear == currentYear && ele?.toYear == currentYear + 1;
                })
                setFilterYear(filterCurrYear?.[0]?.id || "")
                // setFilterYear("");
                setYearOfSahayList(data?.payload)
            } else {
                setYearOfSahayList([])
            }
        })
    }

    //Fetch Sahay List

    const fetchSahayTypeList = () => {
        dispatch(getSahayTypeList()).then((res) => {
            setSahayTypeList(res?.payload)
        })
    }

    useEffect(() => {
        fetchSahayTypeList()
        fetchAllYearOfSahay()
    }, [])
    const rollPermissionNameData = rollPermissionData?.findData?.parentRoleName?.toLowerCase()

    if (
        rollPermissionData?.permissionArray?.includes("Head Of The Family Report_view") ||
        rollPermissionNameData === "admin"
    ) {
    } else {
        Navigate(`/${rollData}/sahay-application`)
    }

    return (
        <>
            {loader ? (
                <PageLoading />
            ) : (
                <>
                    <Index.Box className="page-content-box">
                        <Index.Box className="barge-common-box">
                            <Index.Box className="title-header">
                                <Index.Box className="title-header-flex res-title-header-flex">
                                    <Index.Box className="title-main">
                                        <Index.Typography variant="p" component="p" className="page-title">
                                            Head Of The Family Report
                                        </Index.Typography>
                                    </Index.Box>
                                </Index.Box>
                            </Index.Box>
                            <Index.Box className="grid-row sahay-multiple-main">
                                <Index.Box sx={{ width: 1 }} className="grid-main">
                                    <Index.Box
                                        display="grid"
                                        className="app-report-row"
                                        gridTemplateColumns="repeat(12, 1fr)"
                                        gap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
                                    >
                                        <Index.Box
                                            gridColumn={{
                                                xs: "span 12",
                                                sm: "span 6",
                                                md: "span 3",
                                                lg: "span 3",
                                            }}
                                            className="grid-column"
                                        >
                                            <Index.Box className="sahay-multiple-input-main">
                                                <PagesIndex.Search
                                                    className="search sahay-multiple-search"
                                                    onChange={(e) => requestSearch(e.target.value)}
                                                >
                                                    <PagesIndex.StyledInputBase placeholder="Search" />
                                                </PagesIndex.Search>
                                            </Index.Box>
                                        </Index.Box>

                                        {/* Family ID Filter */}
                                        <Index.Box
                                            gridColumn={{
                                                xs: "span 12",
                                                sm: "span 6",
                                                md: "span 3",
                                                lg: "span 3",
                                            }}
                                            className="grid-column"
                                        >
                                            <Index.Box className="sahay-multiple-input-main">
                                                <Autocomplete
                                                    disablePortal
                                                    id="combo-box-demo"
                                                    className="multiple-autocomplet-control"
                                                    options={listData || []}
                                                    getOptionLabel={(option) => option?.FamilyId?.toString() || ""}
                                                    onChange={(event, newvalue) => {
                                                        setFilter(newvalue?.FamilyId || "")
                                                    }}
                                                    filterOptions={(options, { inputValue }) => {
                                                        const inputLowerCase = inputValue?.toLowerCase()
                                                        const uniqueFamilyId = new Set()
                                                        return options?.filter((option) => {
                                                            const familyId = option?.FamilyId?.toString()?.toLowerCase() || ""
                                                            // Check unique
                                                            if (uniqueFamilyId?.has(familyId)) {
                                                                return false
                                                            }
                                                            // Check search
                                                            if (familyId?.includes(inputLowerCase)) {
                                                                uniqueFamilyId?.add(familyId)
                                                                return true
                                                            }
                                                            return false
                                                        })
                                                    }}
                                                    renderInput={(params) => <Index.TextField {...params} label="Family Id" />}
                                                />
                                            </Index.Box>
                                        </Index.Box>

                                        {/* Name Filter */}
                                        <Index.Box
                                            gridColumn={{
                                                xs: "span 12",
                                                sm: "span 6",
                                                md: "span 3",
                                                lg: "span 3",
                                            }}
                                            className="grid-column"
                                        >
                                            <Index.Box className="sahay-multiple-input-main">
                                                <Autocomplete
                                                    disablePortal
                                                    id="combo-box-demo"
                                                    className="multiple-autocomplet-control"
                                                    options={listData || []}
                                                    getOptionLabel={(option) => option?.Name || ""}
                                                    onChange={(event, newvalue) => {
                                                        setFilterName(newvalue?.Name || "")
                                                    }}
                                                    filterOptions={(options, { inputValue }) => {
                                                        const inputLowerCase = inputValue?.toLowerCase()
                                                        const uniqueNames = new Set()
                                                        return options?.filter((option) => {
                                                            const name = option?.Name?.toLowerCase() || ""
                                                            // Check unique
                                                            if (uniqueNames?.has(name)) {
                                                                return false
                                                            }
                                                            // Check search
                                                            if (name?.includes(inputLowerCase)) {
                                                                uniqueNames?.add(name)
                                                                return true
                                                            }
                                                            return false
                                                        })
                                                    }}
                                                    renderInput={(params) => <Index.TextField {...params} label="Name" />}
                                                />
                                            </Index.Box>
                                        </Index.Box>

                                        {filterReportData?.length > 0 && (
                                            <>
                                                <Index.Box
                                                    gridColumn={{
                                                        xs: "span 12",
                                                        sm: "span 6",
                                                        md: "span 3",
                                                        lg: "span 3",
                                                    }}
                                                    className="grid-column"
                                                >
                                                    <Index.Box className="sahay-multiple-input-main">
                                                        <Index.Box
                                                            Box
                                                            className="res-auto-left common-button blue-button multiple-download-btn res-blue-button"
                                                        >
                                                            <FileExcel apiData={excel} fileName={fileName} />
                                                        </Index.Box>
                                                    </Index.Box>
                                                </Index.Box>
                                                <Index.Box
                                                    gridColumn={{
                                                        xs: "span 12",
                                                        sm: "span 6",
                                                        md: "span 4",
                                                        lg: "span 3",
                                                    }}
                                                    className="grid-column"
                                                >
                                                    <Index.Box className="sahay-multiple-input-main">
                                                        <Index.Box
                                                            Box
                                                            className="res-auto-left common-button blue-button multiple-download-btn res-blue-button"
                                                        >
                                                            <Index.Button onClick={handlePrint}>Print</Index.Button>
                                                        </Index.Box>
                                                    </Index.Box>
                                                </Index.Box>
                                            </>
                                        )}
                                    </Index.Box>
                                </Index.Box>
                            </Index.Box>

                            <Index.Box className="table-list">
                                <Index.TableContainer
                                    sx={{ maxHeight: 480 }}
                                    component={Index.Paper}
                                    className="table-container user-master-container scroll-table"
                                >
                                    <Index.Table
                                        stickyHeader
                                        aria-label="sticky table"
                                        className="table-design-main barge-table user-master-table user-master-table-heading"
                                    >
                                        <Index.TableHead className="user-master-head">
                                            <Index.TableRow className="user-master-tr">
                                                <Index.TableCell className="user-master-th">FId</Index.TableCell>
                                                <Index.TableCell className="user-master-th">Name</Index.TableCell>
                                                <Index.TableCell className="user-master-th">Age</Index.TableCell>
                                                <Index.TableCell className="user-master-th">Gender</Index.TableCell>
                                                <Index.TableCell className="user-master-th">Blood Group</Index.TableCell>
                                                <Index.TableCell className="user-master-th">Marital Status</Index.TableCell>
                                                <Index.TableCell className="user-master-th">Gnyati</Index.TableCell>
                                                <Index.TableCell className="user-master-th">Parent FID</Index.TableCell>
                                                <Index.TableCell className="user-master-th">Old FID</Index.TableCell>
                                                <Index.TableCell className="user-master-th" align="center">
                                                    Address
                                                    {/* <Index.Table
                            aria-label="simple table"
                            className="table-design-main barge-table user-master-table-inner user-master-table-heading-second"
                          >
                            <Index.TableHead>
                              <Index.TableRow>
                                <Index.TableCell>Country</Index.TableCell>
                                <Index.TableCell>State</Index.TableCell>
                                <Index.TableCell>City</Index.TableCell>
                                <Index.TableCell>Pincode</Index.TableCell>
                                <Index.TableCell>Address1</Index.TableCell>
                                <Index.TableCell>Address2</Index.TableCell>
                                <Index.TableCell>Area</Index.TableCell>
                                <Index.TableCell>Mohollo</Index.TableCell>
                              </Index.TableRow>
                            </Index.TableHead>
                          </Index.Table> */}
                                                </Index.TableCell>
                                            </Index.TableRow>
                                        </Index.TableHead>
                                        <Index.TableBody className="user-master-tbody">
                                            {pageData?.length && (filter || filterName || filterYear || sahayFilter) ? (
                                                pageData?.map((data, index) => (
                                                    <Index.TableRow className="user-master-tr" key={index}>
                                                        <Index.TableCell className="user-master-td">
                                                            <Index.Box className="user-role-name">{data?.FamilyId || "-"}</Index.Box>
                                                        </Index.TableCell>
                                                        <Index.TableCell className="user-master-td">
                                                            <Index.Box className="user-role-name">{data?.Name || "-"}</Index.Box>
                                                        </Index.TableCell>
                                                        <Index.TableCell className="user-master-td">
                                                            <Index.Box className="user-role-name">{data?.Age || "-"}</Index.Box>
                                                        </Index.TableCell>
                                                        <Index.TableCell className="user-master-td">
                                                            <Index.Box className="user-details-name">{data?.Gender || "-"}</Index.Box>
                                                        </Index.TableCell>
                                                        <Index.TableCell className="user-master-td">
                                                            <Index.Box className="user-details-name">{data?.Bloodgroup || "-"}</Index.Box>
                                                        </Index.TableCell>
                                                        <Index.TableCell className="user-master-td">
                                                            <Index.Box className="user-details-name">{data?.Maritalstatus || "-"}</Index.Box>
                                                        </Index.TableCell>
                                                        <Index.TableCell className="user-master-td">
                                                            <Index.Box className="user-details-name">{data?.Gnyati || "-"}</Index.Box>
                                                        </Index.TableCell>
                                                        <Index.TableCell className="user-master-td">
                                                            <Index.Box className="user-details-name">
                                                                {Array.isArray(data?.patanHeadDetails) && data.patanHeadDetails.length === 0
                                                                    ? "-"
                                                                    : data?.patanHeadDetails}
                                                            </Index.Box>
                                                        </Index.TableCell>
                                                        <Index.TableCell className="user-master-td">
                                                            <Index.Box className="user-details-name">
                                                                {Array.isArray(data?.oldFamilyHeadDetails) && data.oldFamilyHeadDetails.length === 0
                                                                    ? "-"
                                                                    : data?.oldFamilyHeadDetails === "NULL" || data?.oldFamilyHeadDetails === null || data?.oldFamilyHeadDetails === "undefined"
                                                                        ? "-"
                                                                        : data?.oldFamilyHeadDetails}
                                                            </Index.Box>

                                                        </Index.TableCell>
                                                        <Index.TableCell className="user-master-td">
                                                            <Index.Box className="user-number-name">

                                                                {`${data?.Address?.Country},
${data?.Address?.State},
${data?.Address?.City},
${data?.Address?.Pincode},
${data?.Address?.Address1},
${data?.Address?.Address2},
${data?.Address?.Area},
${data?.Address?.Mohollo}`}
                                                                {/* <Index.Table
                                  aria-label="simple table"
                                  className="table-design-main barge-table user-master-table-inner"
                                >
                                  <Index.TableBody>
                                    <Index.TableRow>
                                      <Index.TableCell>{data?.Address?.Country}</Index.TableCell>
                                      <Index.TableCell>{data?.Address?.State}</Index.TableCell>
                                      <Index.TableCell>{data?.Address?.City}</Index.TableCell>
                                      <Index.TableCell>{data?.Address?.Pincode}</Index.TableCell>
                                      <Index.TableCell>{data?.Address?.Address1}</Index.TableCell>
                                      <Index.TableCell>{data?.Address?.Address2}</Index.TableCell>
                                      <Index.TableCell>{data?.Address?.Area}</Index.TableCell>
                                      <Index.TableCell>{data?.Address?.Mohollo}</Index.TableCell>
                                    </Index.TableRow>
                                  </Index.TableBody>
                                </Index.Table> */}
                                                            </Index.Box>
                                                        </Index.TableCell>
                                                    </Index.TableRow>
                                                ))
                                            ) : (
                                                <PagesIndex.NoRecordFound colSpan={12} />
                                            )}
                                        </Index.TableBody>
                                    </Index.Table>
                                </Index.TableContainer>
                            </Index.Box>
                            <Index.Box className="pagination-design flex-end">
                                <RowPerPageDropdown rowPerPage={rowPerPage} setRowPerPage={setRowPerPage} />
                                <Index.Stack spacing={2}>
                                    <Pagination
                                        fetchData={searchedData}
                                        setPageData={setPageData}
                                        pageData={pageData}
                                        rowPerPage={rowPerPage}
                                    />
                                </Index.Stack>
                            </Index.Box>
                        </Index.Box>
                    </Index.Box>
                    <Index.Box sx={{ display: "none" }}>
                        <PrintReport
                            componentRef={componentRef}
                            tableData={printData}
                            reportName={[{ type: "HeadOfTheFamilyReport" }]}
                        />
                        ;
                    </Index.Box>
                </>
            )}
        </>
    )
}

